import BaseModel from './BaseModel';

class EquipmentCatalogCategoryOrder extends BaseModel {}

export default EquipmentCatalogCategoryOrder;
